import React, {useState} from 'react'
import {Button, Card, Input, Modal, Result, Tag} from "antd"
import {bindXiaoZhiShop, douYinBind, fetchAuthorizeUrl} from "../../../api/clubPlatform"
import {useClubPlatformContext} from "../store/useClubPlatformContext"
import ClubPlatformAvatar from "./ClubPlatformAvator"
import PlatformCode from "../common/ClubPlatformContanst"
import {usePost} from "../../../util/useFetch"

const ClubPlatformUnAuthCard = ({title, platformId, platFormCode = PlatformCode.MeiTuan}) => {
    const [authState, setAuthState] = useState({
        isLoading: false,
        authUrl: '',
        error: null
    })
    const [isClicked, setIsClicked] = useState(false)
    const [isShow, setIsShow] = useState(false)
    const [douYinShopId, setDouYinShopId] = useState("")

    const {getRelationStore} = useClubPlatformContext()

    const getAuthorizeUrl = async () => {
        setAuthState(prevState => (
            {
                ...prevState,
                isLoading: true
            })
        )
        try {

            const {status, detail, data} = await fetchAuthorizeUrl(platformId)
            if (status !== 1) {
                throw new Error(detail)
            }
            setAuthState(prevState => (
                {
                    ...prevState,
                    authUrl: data.authUrl
                }
            ))
            window.open(data.authUrl)
            setIsClicked(true)
        } catch (e) {
            setAuthState(prevState => (
                {
                    ...prevState,
                    error: e.message
                }
            ))
        } finally {
            setAuthState(prevState => (
                {
                    ...prevState,
                    isLoading: false
                }
            ))
        }
    }

    const handleComplete = async () => {
        if (platformId === PlatformCode.MeiTuan) {
            await bindXiaoZhiShop()
        }
        await getRelationStore()
    }


    const handleAuthorize = async () => {
        await getAuthorizeUrl()

    }


    const handleDouYinBind = usePost(() => douYinBind(douYinShopId), {
        callback: async () => {
            await getRelationStore()
        }
    })


    if (authState.error) {
        return <Result status={"error"} subTitle={`获取授权url失败：${authState.error}`}/>
    }


    return (
        <div>
            <Card
                style={{width: 400}}
                title={
                    <div>
                        <ClubPlatformAvatar platformId={platformId}/>
                        <span style={{marginLeft: "20px"}}>{title}</span>
                    </div>
                }
                extra={<Tag color="blue">未授权</Tag>}
            >
                <Result
                    style={{padding: 20, height: 200}}
                    status={"info"}
                    subTitle={"暂未授权，点击下方按钮授权"}
                    extra={<div>
                        {!isClicked &&
                            <Button onClick={handleAuthorize}
                                    type={"primary"}
                                    loading={authState.isLoading}
                            >
                                去授权
                            </Button>}
                        {isClicked &&
                            <Button onClick={() => handleComplete(platformId)}
                                    style={{marginLeft: "10px"}}
                            >
                                已完成授权
                            </Button>}
                    </div>}
                />
                <Modal
                    title={"手动绑定"}
                    open={isShow}
                    onOk={handleDouYinBind.updateData}
                    onCancel={() => setIsShow(false)}
                    confirmLoading={handleDouYinBind.isLoading}
                >
                    <div style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center"
                    }}>
                        <div>请输入抖音商户ID：</div>
                        <Input style={{width: 300}}
                               value={douYinShopId}
                               onChange={(e) => setDouYinShopId(e.target.value)}
                               placeholder={"请输入抖音商户ID"}
                        ></Input>
                    </div>
                </Modal>

            </Card>

        </div>
    )
}


export default ClubPlatformUnAuthCard


// WEBPACK FOOTER //
// ./src/containers/ClubPlatform/component/ClubPlatformUnAuthCard.js